import { render, staticRenderFns } from "./QuestionNavigator.vue?vue&type=template&id=6fc981f6&scoped=true&lang=html&"
import script from "./QuestionNavigator.vue?vue&type=script&lang=js&"
export * from "./QuestionNavigator.vue?vue&type=script&lang=js&"
import style0 from "./QuestionNavigator.vue?vue&type=style&index=0&id=6fc981f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc981f6",
  null
  
)

export default component.exports